import 'owl.carousel';
import "magnific-popup";

jQuery( document ).ready(function($) {

    $('.home-carousel').owlCarousel({
        loop:true,
        margin:10,
        nav:true,
        dots: false,
        items: 1,
        navText: [
            '<i class = "fas fa-chevron-left"></i><span class = "sr">Previous</span>',
            '<i class = "fas fa-chevron-right"></i><span class = "sr">Next</span>'
        ]
    });

    $('.menu-toggle').on('click', function(e){
        e.preventDefault();
        $('.nav-menu').toggleClass('open');
    });
    
    // Gallery
    $('.gallery a').magnificPopup({
        type: 'image',
        gallery: {
            enabled: true
        }
    });

    // Videos
    $('.video a').magnificPopup({
        type: 'iframe',
        gallery: {
            enabled: true
        }
    });
});